import { AutoCompleteOption } from "@asayinc/component-library";

export const ISSUER_TYPE_OPTIONS: AutoCompleteOption[] = [
  {
    name: "Corporation",
    id: "corporation",
  },
  {
    name: "Investment Trust",
    id: "investment_trust",
  },
];
